module.exports = __webpack_public_path__ + "img/service_icon_3.1462f2dd.svg";